import TextField from "@mui/material/TextField";
import AddItemDialog from "../../Dialogs/AddItemDialog";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../..";
import { createErrorText } from "../Functions";

const FolderExistsDialog = ({
  open,
  handleCancel,
  moveAndRenameFolder,
  targetPathString,
}: {
  open: boolean;
  handleCancel: () => void;
  moveAndRenameFolder: (targetPath: string, newName: string) => void;
  targetPathString: string;
}) => {
  const [name, setName] = useState("");
  const selectedRow = useSelector((state: RootState) => state.examOverview.selectedRow);
  const itemName = selectedRow?.name;
  const paths = useSelector((state: RootState) => state.examOverview.paths);
  const [errorText, setErrorText] = useState<string | null>(null);

  const resetFields = () => {
    if (!open) {
      setName("");
    } else if (itemName) {
      setName(itemName);
    }
  };

  useEffect(() => {
    resetFields();
  }, [open]);

  useEffect(() => {
    setErrorText(createErrorText(paths, targetPathString, name));
  }, [name]);

  return (
    <AddItemDialog
      open={open}
      handleCancel={() => handleCancel()}
      handleConfirm={() => moveAndRenameFolder(targetPathString, name)}
      title={"Ordner umbenennen"}
      description={"Wähle einen neuen Namen"}
      confirmText={"OK"}
      confirmAllowed={errorText === null}
    >
      <TextField
        margin="dense"
        id="name"
        label="Name"
        required
        error={errorText !== null}
        style={{ width: 330 }}
        autoFocus
        value={name}
        onChange={(e) => {
          setName(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.code === "Enter" && errorText === null) {
            moveAndRenameFolder(targetPathString, name);
          }
        }}
        helperText={errorText ?? errorText}
      />
    </AddItemDialog>
  );
};

export default FolderExistsDialog;
